<script setup lang="ts">
import { computed, watch, onMounted } from 'vue'
import type { SurveyQuestion } from '@/types/surveyTypes'
import { Field, ErrorMessage } from 'vee-validate'
import { useSurvey, AnswerTarget } from '@/composables/onlineSurvey/useSurvey'

const { setAnswer, answers } = useSurvey()

const props = defineProps<{
  question: SurveyQuestion
  answerTarget?: AnswerTarget
}>()

const fieldName = computed(() => props.question.id)

const handleInput = (value: string) => {
  setAnswer(props.question.id, props.question.label, value || null, props.answerTarget)
}

const initializeValue = () => {
  const existingAnswer = answers.value.find((a) => a.id === props.question.id)
  if (existingAnswer !== undefined) {
    return existingAnswer.answer
  }
  return undefined
}

onMounted(() => {
  initializeValue()
})

watch(
  () => answers.value.find((a) => a.id === props.question.id),
  () => {
    initializeValue()
  },
)
</script>

<template>
  <div class="field">
    <div class="control">
      <Field
        :id="props.question.id"
        :name="fieldName"
        :value="initializeValue()"
        type="text"
        :placeholder="props.question.placeholder || 'Antwort...'"
        @update:modelValue="handleInput"
        v-slot="{ field, errorMessage }"
      >
        <input
          v-bind="field"
          type="text"
          class="input"
          :placeholder="props.question.placeholder || 'Antwort...'"
        />
      </Field>
    </div>
    <ErrorMessage :name="fieldName" class="help is-danger" />
  </div>
</template>

<style scoped>
@import '../../../assets/main.css';
</style>
